import React, { FC, useEffect } from 'react';
import { reportEvent } from 'Shared/analytics';
import { ClearcoverSupport } from 'Shared/components';
import { AllowedSoftStops } from 'QuoteApp/services/endpoints/GetDetails';
import { useAppContext } from 'QuoteApp/services/providers';
import styles from './styles.module.css';

const defaultContent = {
  title: 'Contact us for assistance.',
  content:
    'We are unable to offer a quote online. To continue, contact Clearcover Agent Support by chat or call 507-564-4693.',
};

export const SOFT_STOPS: Record<
  AllowedSoftStops,
  { title: string; content: string }
> = {
  tier_5: {
    title: defaultContent.title,
    content: defaultContent.content,
  },
};

export const SoftStop: FC = () => {
  const { details } = useAppContext();
  const softStop = details.softStops.find((stop) => stop.displaySoftStop);

  useEffect(() => {
    if (softStop) {
      reportEvent('aqui-soft-stop', {
        softStopType: softStop.softStopType,
      });
    }
  }, [softStop]);

  // Router handles the case where there is no soft stop
  return softStop ? (
    <div className={styles.page} data-testid="soft-stop-page">
      <ClearcoverSupport
        testId="aqui-soft-stop"
        title={SOFT_STOPS[softStop.softStopType]?.title || defaultContent.title}
      >
        <p>
          {SOFT_STOPS[softStop.softStopType]?.content || defaultContent.content}
        </p>
      </ClearcoverSupport>
    </div>
  ) : null;
};
